/**
 * useEmailDraft — pick the right path for an email draft.
 *
 *   const { open, dialogProps } = useEmailDraft();
 *   open({ subject, body });
 *
 * If the encoded mailto URL fits the inline limit (single-account
 * drafts always do), opens the user's default mail client immediately.
 * Otherwise sets dialog state so the page can render the
 * EmailDraftDialog manual-copy fallback.
 *
 * Mount the dialog once at the page level:
 *   <EmailDraftDialog {...dialogProps} />
 *
 * The same hook drives both the page-toolbar "Email full review" and
 * the drilldown modal "Email account summary" actions.
 *
 * TEMP: orphan after FSD merge.
 */
import { useCallback, useState } from 'react';
import { canInlineDraft, openDraftEmail } from './emailContent';

export const useEmailDraft = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    subject: '',
    body: '',
  });

  const close = useCallback(() => {
    setDialogState((prev) => ({ ...prev, open: false }));
  }, []);

  const open = useCallback(({ subject, body }) => {
    if (canInlineDraft({ subject, body })) {
      openDraftEmail({ subject, body });
      return;
    }
    setDialogState({ open: true, subject, body });
  }, []);

  return {
    open,
    dialogProps: {
      open: dialogState.open,
      subject: dialogState.subject,
      body: dialogState.body,
      onClose: close,
    },
  };
};

export default useEmailDraft;
